import * as yup from 'yup';

export const chatSchema = yup.object().shape({
  message: yup.string().min(1).max(255).trim(),
});
